import { Wrench } from 'lucide-react';
import type { ModuleDefinition } from '../../core/shared/types/index.js';

const buitendienstManifest: ModuleDefinition = {
  id: 'buitendienst',
  name: 'Buitendienst',
  icon: <Wrench size={20} />,
  color: 'var(--brand-primary)',
  basePath: '/buitendienst',
  status: 'active',
  navItems: [
    { label: 'Dossiers', path: '/buitendienst/dossiers', icon: '' },
    { label: 'Pipeline', path: '/buitendienst/pipeline', icon: '' },
    { label: 'Contacten', path: '/buitendienst/contacten', icon: '' },
    { label: 'Planning', path: '/buitendienst/planning', icon: '' },
    { label: 'Route', path: '/buitendienst/route', icon: '' },
    { label: 'Documenten', path: '/buitendienst/documenten-inbox', icon: '' },
    { label: 'Rapportage', path: '/buitendienst/rapportage', icon: '' },
    { label: 'Plaatsingen', path: '/buitendienst/plaatsingen', icon: '' },
    { label: 'Tijdregistratie', path: '/buitendienst/tijdregistratie', icon: '' },
    { label: 'Logistiek', path: '/logistiek', icon: '' },
    { label: 'Configuratie', path: '/buitendienst/config', icon: '' },
  ],
  component: () => import('./index.js'),
};

export default buitendienstManifest;
